<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons-round danger">logout</span>
        <span class="soc-panel-h">{{'TRANSFER.OUTGOING_TRANSFER_DETAILS' | translate}}</span>
        <span [ngClass]="transfer.statusType == InventoryActionStatus.Pending ? 'soc-pill-lbl soc-danger-pill-outline' : 'soc-pill-lbl soc-neutral-30-pill-outline'">{{transfer.statusType}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <div class="pos-actions-wrapper">
        <div class="soc-wrapper-gap-24 w-100">
            <div *ngIf="transfer.issuedByUser" class="soc-display-field-wrapper w-100">
                <label class="soc-input-lbl w-100 text-start">{{'TRANSFER.ISSUED_BY' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{transfer.issuedByUser.firstName}} {{transfer.issuedByUser.lastName}}</span></div>
            </div>
            <div class="soc-display-field-wrapper w-100">
                <label class="soc-input-lbl w-100 text-start">{{'TRANSFER.ISSUE_DATE' | translate}}</label>
                <div *ngIf="transfer.issuedOn" class="soc-display-field"> <span class="soc-display-text">{{transfer.issuedOn | tzConvert: timezoneOffset:'DD MMM YYYY'}}</span></div>
            </div>
            <div *ngIf="transfer.receivedByUser" class="soc-display-field-wrapper w-100">
                <label class="soc-input-lbl w-100 text-start">{{'TRANSFER.RECIEVED_BY' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{transfer.receivedByUser.firstName}} {{transfer.receivedByUser.lastName}}</span></div>
            </div>
            <div *ngIf="transfer.receivedOn" class="soc-display-field-wrapper w-100">
                <label class="soc-input-lbl w-100 text-start">{{'TRANSFER.ISSUE_DATE' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{transfer.receivedOn | tzConvert: timezoneOffset:'DD MMM YYYY'}}</span></div>
            </div>
            <div class="soc-display-field-wrapper w-100">
                <span class="soc-input-lbl w-100 text-start">{{"TRANSFER.DESTINATION_INVENTORY" | translate}}</span>
                <div class="soc-display-field"> <span class="soc-display-text">{{transfer.destinationVenueInventory?.name}}</span></div>   
            </div>          
        </div>     
    </div>
    <p-table *ngIf="transfer.lineItems" class="soc-borderless-table" [value]="transfer.lineItems" [scrollable]="true" [virtualScroll]="true" scrollHeight="calc(100vh - 462px)">
        <ng-template pTemplate="header">
            <tr> 
                <th>{{"INVENTORY_ITEM.CODE" | translate}}</th> 
                <th>{{"INVENTORY_ITEM.ITEM_NAME" | translate}}</th> 
                <th>{{"INVENTORY_ITEM.QUANTITY" | translate}}</th> 
                <th></th>
            </tr> 
        </ng-template>
        <ng-template pTemplate="body" let-transferItem  let-rowIndex="rowIndex">            
            <tr>
                <td class="secondary-td">{{transferItem.item.code}}</td>
                <td>{{transferItem.item.name}}</td>
                <td>{{transferItem.quantitySent}} {{transferItem.item.unitType | unitShortener | lowercase}}</td>
                <td></td>
            </tr> 
        </ng-template>
    </p-table>
    <hr class="soc-panel-line"/>
    <div class="d-flex align-items-center justify-content-between">
        <button class="soc-secondary-grey-btn" (click)="navigateToMain()" ><span class="material-icons-round">arrow_back</span>{{"BACK" | translate}}</button>
        <button *ngIf="transfer.statusType == InventoryActionStatus.Pending" class="soc-basic-orange-btn" (click)="cancelTransfer()">{{"TRANSFER.CANCEL_TRANSFER" | translate}}</button>
    </div>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
<p-toast position="top-center"></p-toast>